import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { insertUrlEvt } from 'modules/actions/insertUrlEvent';
import { useDispatch, useSelector } from 'react-redux';

const handleMoreButtonClick = () => {
  try {
    const url = 'https://www.yongin.go.kr/user/bbs/BD_selectBbsList.do?q_bbsCode=1210';
    const form = document.createElement('form');
    form.target = '_blank';
    form.method = 'POST';
    form.action = url;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'someFieldName';
    input.value = 'someValue';
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  } catch (error) {
    console.log('Error:', error);
  }
};

const StatListBtnElement = ({ onClickEvt, data, styleDef, msgIndex }) => {
  const intentId = useSelector(state => state.chatList)?.data[msgIndex].intentId;
  const dispatch = useDispatch();
  const sessionId = sessionStorage.getItem('session_id') || '';
  const userId = sessionStorage.getItem('user_id') || '';
  return (
    <div
      className="_list_btn_button"
      style={styleDef}
      role="button"
      tabIndex={0}
      onClick={e => {
        if (data.button.action === 'url') {
          dispatch(insertUrlEvt({ label: data.button.label, intentId, sessionId, userId }));

          const inStr = data.button.value;
          window.open(inStr.replace(/&amp;/g, '&'));
        } else {
          onClickEvt(data.button.value, data.button.action, data.button.label);
        }
      }}
      onKeyPress={e => {
        if (e.key === 'Enter') {
          onClickEvt(data.button.value, data.button.action, data.button.label);
        }
      }}
    >
      {ReactHtmlParser(data.button.label)}
    </div>
  );
};

const StatListButton = ({ boxStyle, item, viewType, onClickEvt, msgIndex }) => {
  const { items, type } = item;

  return (
    <>
      <div className="_list_btn">
        <div className="_title">
          {ReactHtmlParser(items[0].text.desc)}
          <div className="_more-button" onClick={e => handleMoreButtonClick()}>
            더보기
          </div>
        </div>
        {items.map((data, number) => {
          return <StatListBtnElement key={'stat_list_btn_ele_' + number} styleDef={boxStyle} onClickEvt={onClickEvt} data={data} msgIndex={msgIndex} />;
        })}
      </div>
    </>
  );
};
StatListButton.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
  msgIndex: PropTypes.number,
};
StatListButton.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise',
  onClickEvt: null,
  msgIndex: 0,
};

StatListBtnElement.propTypes = {
  data: PropTypes.object,
  onClickEvt: PropTypes.func,
  styleDef: PropTypes.object,
  msgIndex: PropTypes.number,
};
StatListBtnElement.defaultProps = {
  data: {},
  onClickEvt: null,
  styleDef: {},
  msgIndex: 0,
};

export default StatListButton;
